'use client'
import { useTranslations } from 'next-intl'
import clsx from 'clsx'
import { Link } from '@/i18n/navigation'

import WithQueryParams from '@/hoc/withQueryParams'

import Icon from '@/components/atoms/Icon'
import Button from '@/components/atoms/Button'
import { ButtonSize } from '@/components/atoms/Button/Button.types'
import { ButtonLabel } from '@/components/atoms/Typography'
import styles from './ApplyLink.module.scss'

const ApplyLink = ({
  href,
  label,
  autoWidth = false,
  className,
  size,
  source,
  disabled = false,
  componentName,
}: {
  href: string
  label?: string
  autoWidth?: boolean
  className?: string
  size?: ButtonSize
  source?: string
  disabled?: boolean
  componentName: string
}) => {
  const t = useTranslations('General')
  const applyLabel = t('applyNow')
  const onClick = () => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({ apply_link_clicked: source })
    }
  }

  const buttonLabel = disabled ? t('comingSoon') : label || applyLabel

  let buttonProps = {}
  if (!disabled) {
    buttonProps = {
      href,
      onClick,
      as: Link,
      Icon: () => <Icon iconName='ArrowRight' />,
    }
  }

  return (
    <Button
      id={`${componentName}-apply-link`}
      size={size}
      {...buttonProps}
      className={clsx(styles.link, className)}
      autoWidth={autoWidth}
      disabled={disabled}
    >
      <ButtonLabel
        size='md'
        family='serif'
      >
        {buttonLabel}
      </ButtonLabel>
    </Button>
  )
}

export default WithQueryParams(ApplyLink)
